<template>
<div>
	<header style="
    padding:  50px;
    text-align:  center;
    background: #0055a9;
    margin-bottom: 30px;
	">
	<h1 style="color: white;">{{ treatAsEnquiry? strings.completeYourInquiry: strings.completeYourBooking }}</h1>
	</header>
	<div class="container layout" >
	<div class="row">
		<div class="col-lg-7 col-xl-7">
			<!-- Your details -->
			<h2 class="checkout-title">{{ strings.yourDetails }}</h2>
			<form ref="form">
				<div>
					<label class="form__label input-group__item">{{ strings.name }}
						<input ref="name" v-validate="'required'" :class="{'input': true, 'form--invalid': errors.has('name') }" type="text" :data-vv-as="strings.name" name="name" class="form__input" :placeholder="strings.yourname" v-model="ck_name">
						<p v-show="errors.has('name')" class="form__note">{{ errors.first('name') }}</p>
					</label>

					<label class="form__label input-group__item">{{ strings.lname }}
						<input ref="lname"  v-validate="'required'" :class="{'input': true, 'form--invalid': errors.has('lname') }" type="text" :data-vv-as="strings.lname" name="lname" class="form__input" :placeholder="strings.yourlastname" v-model="ck_lname">
						<p v-show="errors.has('lname')" class="form__note">{{ errors.first('lname') }}</p>
					</label>

					<label class="form__label input-group__item">{{ strings.email }}
						<input ref="email" v-validate="'required|email'" :class="{'input': true, 'form--invalid': errors.has('email') }" type="text" :data-vv-as="strings.email" name="email" class="form__input" :placeholder="strings.youremail" v-model="ck_email">
						<p v-show="errors.has('email')" class="form__note">{{ errors.first('email') }}</p>
					</label>

					<label class="form__label input-group__item">{{ strings.phone }}<span class="aside__detail"> {{ strings.includingDialCode }}</span>
						<input  ref="phone"  v-validate="'required'" :class="{'input': true, 'form--invalid': errors.has('phone') }" type="text" :data-vv-as="strings.phone" name="phone" class="form__input" :placeholder="strings.phoneNumber" v-model="ck_phone">
						<p v-show="errors.has('phone')" class="form__note">{{ errors.first('phone') }}</p>
					</label>

					<label class="form__label input-group__item">{{ strings.company }}
						<input ref="company"  v-validate="'required'" type="text" name="company" class="form__input" :placeholder="strings.company" v-model="ck_company" :disabled="isDisabled">
						<p v-show="errors.has('company')" class="form__note">{{ errors.first('company') }}</p>
					</label>

					<label class="form__label input-group__item">{{ strings.onsitecontact }}
						<input ref="onsitecontact" type="text" name="onsitecontact" class="form__input" :placeholder="strings.onsitecontact_placeholder" v-model="ck_onsitecontact" :disabled="isDisabled">
					</label>
				</div>
			<label class="form__label input-group__item">{{ strings.additional_info }}  </label>
			<textarea
				class="form__textarea" name="additional_info"
				:placeholder="strings.additional_info_placeholder"
				v-model="ck_additional_info"
			></textarea>
			</form>			
			<!-- Add ons -->
			<h2 v-if="checkOutItems.length > 1 && checkOutItems[0].type !== 'package'" class="checkout-title">{{ strings.addOns }}  <span style="font-weight:400; color: #777777">{{ strings.optionalItems }}</span></h2>
			<h2 v-if="checkOutItems.length > 1 && checkOutItems[0].type == 'package'" class="checkout-title">Events</h2>
			<MultiDayCheckout v-if="checkOutItems.length > 1" :menus="operaMenus" :misc="operaMiscItems"></MultiDayCheckout>

			<div class="addons" v-if="checkOutItems.length == 1 && checkOutItems[0].type == 'room'">
				<h2 class="checkout-title">{{ strings.addOns }}  <span style="font-weight:400; color: #777777">{{ strings.optionalItems }}</span></h2>
				<h3>{{ strings.menus }} </h3>

				<multiselect :max="maxMenu" v-model="valueMenu" :placeholder="strings.searchForMenus" label="name" track-by="id" :options="operaMenus" :hideSelected="true" :multiple="true" selectLabel=" "></multiselect>
			
				<table-component
					style="margin-bottom: 0px !important;"
					v-show="valueMenu.length > 0"
					:show-filter="false"
					:data="valueMenu"
					sort-by="name"
					sort-order="asc"
					filter-no-results="There is no item in the list"
				>
					<table-column show="name" label="Menu name" cell-class="tableCellClass"></table-column>
					<table-column label="Service time" cell-class="tableCellClass" header-class="serviceTimeInput">
						<template scope="row">
							<select :value="row.service_time" :data-id="row.id" class="form__input service_time_from" @change="changeMenuServiceTime($event)"> 
								<option v-show="isServiceTimeBetween(item.value)" v-for="item in serviceTimeList" :key="item.id" :value="item.value"> {{ item.text }} </option> 
							</select>
						</template>
					</table-column>
					<table-column label="Delegates" header-class="amountInput">
						<template scope="row">
							<input type="number" :data-id="row.id" class="form__input" :value="row.amount" @change="changeMenuTotal($event)" />
						</template>
					</table-column>
					<table-column show="priceWithCC" label="Price" cell-class="tableCellClass"></table-column>
					<template slot="tfoot" scope="{ rows }" >
						<tr v-show="valueMenu.length > 0">
							<th>{{ strings.total }}</th>
							<th></th>
							<th></th>
							<th>{{ rows.reduce((sum, value) => { return sum + (value.data.price * value.data.amount); }, 0).toFixed(2) }} {{ checkOutItems[0].currencySymbol }}</th>
						</tr>
					</template>
				</table-component>

				<h3 v-if="operaMiscItems.length > 0" style="margin-top: 20px !important;">{{ strings.miscellaneousItems }}</h3>
				<multiselect v-model="valueMisc" :placeholder="strings.searchForMiscItems" label="name" track-by="id" :options="operaMiscItems" :multiple="true" :hideSelected="true" selectLabel=" "></multiselect>
			
				<table-component
					v-show="valueMisc.length > 0"
					:show-filter="false"
					:data="valueMisc"
					sort-by="name"
					sort-order="asc"
					filter-no-results="There is no item in the list"
				>
					<table-column show="name" label="Item name" cell-class="tableCellClass"></table-column>
					<table-column label="Service time" cell-class="tableCellClass" header-class="serviceTimeInput">
						<template scope="row">
							<select :value="row.service_time" :data-id="row.id" class="form__input service_time_from" @change="changeMiscServiceTime($event)"> 
								<option v-show="isServiceTimeBetween(item.value)" v-for="item in serviceTimeList" :key="item.id" :value="item.value"> {{ item.text }} </option> 
							</select>
						</template>
					</table-column>
					
					<table-column label="Amount" header-class="amountInput">
						<template scope="row">
							<!-- if there is item availability then we need to change the input to select option -->
							<select class="form__input" :data-id="row.id" :value="row.amount" @change="changeTotal($event)" v-if="row.availability">
								<option 
									v-for="n in row.availability[convertDate(checkOutItems[0].startD)]" 
									:value="n" 
									:selected="n == row.amount"
									:key="n">{{ n }}</option>
							</select>
							<input type="number" :data-id="row.id" class="form__input" :value="row.amount" @change="changeTotal($event)" v-else/>
						</template>
					</table-column>
					<table-column show="priceWithCC" label="Price" cell-class="tableCellClass" header-class="amountInput"></table-column>
					<template slot="tfoot" scope="{ rows }" >
						<tr v-show="valueMisc.length > 0">
							<th>{{ strings.total }}</th>
							<th></th>
							<th></th>
							<th>{{ rows.reduce((sum, value) => { return sum + (value.data.price * value.data.amount  * temp(checkOutItems[0].mt_length, value.data.isHourlyRate)); }, 0).toFixed(2) }} {{ checkOutItems[0].currencySymbol }}</th>
						</tr>
					</template>
				</table-component>
			</div>

<h2 class="checkout-title">{{ strings.bookingRequestSummary }}</h2>
<div class="col-md-12 venue-details-item full-info" v-bind:class="{'multiday-summary': checkOutItems.length > 1 }">
			<div class="full-info-item" v-show ="checkOutItems.length == 1">
				<div class="info-label">{{ strings.startTime }}</div>
				<div class="info">{{ checkOutItems[0].startD }}</div>
			</div>
			<div class="full-info-item" v-show ="checkOutItems.length == 1">
				<div class="info-label">{{ strings.endTime }}</div>
				<div class="info">{{ checkOutItems[checkOutItems.length - 1].endD }}</div>
			</div>
			<div v-show ="checkOutItems.length > 1" >
				<div class="accordion-block" v-for="(item, id) in checkOutItems">
					<div class="accordion-toggle" block v-b-toggle="'accordion-overview-' + id " variant="info">
						{{ strings.day }} {{ id + 1 }}
						<span class="accordion-plus">+</span>
						<span class="accordion-minus">-</span>
						<span class="accordation-price hide">{{ item.total_price }}  {{ item.currencySymbol }} </span>
				</div>
				<b-collapse :visible="id == 0" v-bind:id="'accordion-overview-' + id "  accordion="my-accordion" role="tabpanel">
						<b-card>
							<div class="full-info-item" v-show="(item.total_services + item.total_addons) > 0">
								<div class="info-label">{{ strings.addOns }}</div>
								<div class="info room-detail">{{ (parseFloat((item.total_services + item.total_addons)/ 100)).toFixed(2) }} {{ item.currencySymbol }}</div>

							</div>
							<div class="full-info-item">
								<div class="info-label">{{ strings.total }}</div>
								<div class="info room-detail">{{ parseFloat(item.total_price / 100).toFixed(2) }} {{ item.currencySymbol }}</div>
							</div>
						</b-card>
				</b-collapse>	
				</div>
			</div>

			<div class="full-info-item" v-show="checkOutItems[0].type == 'package'">
				<div class="info-label">{{ strings.DDRPackage }}</div>
				<div class="info product-info">{{ packageNameString }}</div>
			</div>
			<div class="full-info-item" v-show ="checkOutItems.length == 1">
				<div class="info-label">{{ strings.Room }}</div>
				<div class="info room-detail">{{ checkOutItems[0].room.name }}</div>
			</div>
			<div class="full-info-item" v-if="checkOutItems[0].type == 'room' && checkOutItems.length == 1">
				<div class="info-label del-price">{{ strings.roomHirePrice }}</div>
				
				<div class="info">{{ parseFloat(checkOutItems[0].room.unit_price / 100) > 0 ? parseFloat(checkOutItems[0].room.unit_price / 100).toFixed(2) : strings.inquiry }} {{ parseFloat(checkOutItems[0].room.unit_price / 100) > 0 ? checkOutItems[0].currencySymbol : '' }}</div>
			</div>
			<div class="full-info-item" v-if="checkOutItems[0].type == 'package' && checkOutItems.length == 1">
				<div class="info-label del-price">{{ strings.pricePerDelegate }}</div>
				
				<div class="info">{{ parseFloat(checkOutItems[0].package.unit_price / 100) > 0 ? parseFloat(checkOutItems[0].package.unit_price / 100).toFixed(2) : strings.inquiry }} {{ parseFloat(checkOutItems[0].package.unit_price / 100) > 0 ? checkOutItems[0].currencySymbol : '' }}</div>
			</div>
			<div class="full-info-item" v-show ="checkOutItems.length == 1">
				<div class="info-label">{{ strings.Delegates }}</div>
				<div id="delegate_quantity" class="info"> {{ checkOutItems[0].delegates }}</div>
			</div>
			<div v-show ="checkOutItems.length == 1" class="full-info-item">
				<div class="info-label">{{ strings.seatingOrder }}</div>
				<div class="info">{{ checkOutItems[0].room.layout_name }}</div>
			</div>

			<div class="total full-info-item addonTotal" v-show="addOnsTotalPrices > 0">
				<div class="info-label">{{ strings.addOns }}</div>
				<div class="info">{{ parseFloat(addOnsTotalPrices) > 0 ? parseFloat(addOnsTotalPrices ).toFixed(2) : strings.inquiry }} {{ parseFloat(addOnsTotalPrices) > 0 ? checkOutItems[0].currencySymbol : '' }}</div>
			</div>

			<div class="total full-info-item totalPrice" v-show ="checkOutItems.length > 1">
				<div class="info-label" style="font-weight:700">{{ strings.total }} <span style="font-weight:400">{{ strings.inclVAT }}</span></div>
				<div class="info" style="font-weight:700">{{ parseFloat(checkOutItems.reduce((sum, value) => { return sum + parseInt(value.total_price); }, 0) / 100).toFixed(2)  }} {{ checkOutItems[0].currencySymbol }}</div>
			</div>
			<div class="total full-info-item totalPrice" v-show ="checkOutItems.length == 1">
				<div class="info-label" style="font-weight:700">{{ strings.total }} <span style="font-weight:400">{{ strings.inclVAT }}</span></div>
				<div class="info" style="font-weight:700"> {{ parseFloat(totalPrice / 100) > 0 ? parseFloat(totalPrice / 100).toFixed(2) : strings.inquiry }} {{ parseFloat(totalPrice / 100) > 0 ? checkOutItems[0].currencySymbol : '' }}</div>
			</div>
		</div>	
			<div v-if="showPaymentMethods" class="paymentType">
				<h2 class="checkout-title">{{strings.choosePaymentMethod}}</h2>		
				<!--<h2 class="checkout-title">{{strings.creditCardPayment}}</h2>-->	
				<div class="selectPaymentType" >		
					<div class="paymentTypeInputWrapper"> 
						<input type="radio" id="creditcardMethod" value="creditcard" v-model="selectedPaymentMethod">
						<label for="creditcardMethod"> <span class="mp-customized-input"></span> {{strings.creditCardTitle}}</label>
					</div>
					<div class="paymentTypeInputWrapper">	
						<input type="radio" id="accountCreditsMethod" value="accountcredits" v-model="selectedPaymentMethod">
						<label for="accountCreditsMethod"> <span class="mp-customized-input"></span> {{strings.accountcreditsTitle}}</label>
					</div>
				</div>
				<PCICaptureToken v-if="selectedPaymentMethod == 'creditcard'" @successCB="cardTokenCaptured" @errorCB="cardTokenFailure" ></PCICaptureToken>
				<div class="accountcredits" v-if="selectedPaymentMethod == 'accountcredits'">
					<label class="form__label input-group__item">{{strings.customerAccountLabel}}:
						<div class="account-credits-label-info">{{strings.customerAccountLabelInfo}}</div>
						<input ref="customeraccount" :data-vv-as="'AR number'" v-validate="'required'" type="text" name="customeraccount" class="form__input" :placeholder="strings.customerAccountPlaceholder" v-model="ck_customeraccount" :disabled="isDisabled">
						<p v-show="errors.has('customeraccount')" class="form__note">{{ errors.first('customeraccount') }}</p>
					</label>
					<div style=" margin-bottom: 15px;">{{strings.checkoutAccountcreditsNotice}}</div>
				</div>
			</div>
			<div v-show="booking_errors" class="alert alert-danger" > {{booking_errors}} </div>
			<div class="checkBoxAgree">
				<input type="checkbox" id="checkboxAgree" v-model="checkboxAgree">
				<label v-if="isUrl(venue.terms)" for="checkboxAgree"> <span class="mp-customized-input"></span> {{ strings.haveRead }} 
					<a v-bind:href="venue.terms" target="_blank" >{{ strings.termsNConditions }}</a> {{strings.and}} <a class="cancelationPolicyLink" @click="show()">{{strings.cancelationPolicy}}</a>
				</label>
				<label v-if="!isUrl(venue.terms)" for="checkboxAgree"> <span class="mp-customized-input"></span> {{ strings.haveRead }} 
					
					<a target="_blank" @click.prevent="showTermsModal()" href="/terms">{{ strings.termsNConditions }}</a> {{strings.and}} <a class="cancelationPolicyLink" @click="show()">{{strings.cancelationPolicy}}</a>
				</label>
				<v-dialog/>
			</div>
			<button type="submit" href="" class="button button--success button--full tabs__button" :class="{'button--disabled':!checkboxAgree }" @click="submitForm()">{{ treatAsEnquiry ? strings.sendRequest : strings.book }}</button>
		</div>
	<div class="col-lg-5 col-xl-5 venue-summary" style="border: 0px solid black" >
		<carousel v-if="photos.length" :perPage="1" :navigationEnabled="false" :paginationSize="15">
			<slide v-for="(item, key) in photos" :key="key">
				<img :src="item" alt="">
			</slide>
		</carousel>
		<div class="checkout-room-title">
			<h3 style="text-align:center;"> {{ venue.title }}</h3>
		</div>
		</div>
	</div>	
</div>
</div>

  
</template>

<script>
import VModal from 'vue-js-modal'
import VuePhoneInput from './VuePhoneInput'
import Multiselect from 'vue-multiselect'
import MultiDayCheckout from './MultiDayCheckout'
import PCICaptureToken from './PCICaptureToken'
import * as hf from '../assets/misc/helperFunctions.js'
import moment from 'moment';
import Vue from 'vue'
import VueResource from 'vue-resource';
import VeeValidate from 'vee-validate';
import BootstrapVue from 'bootstrap-vue';
Vue.use(BootstrapVue);
Vue.use(VueResource);
Vue.use(VeeValidate);
Vue.use(VModal, { dynamic: true, injectModalsContainer: true })
export default {
	filters: {
       // to Array
        Array(value) {
			var _array = [];
			_array.push(value);
            return _array;
        }
    },
	data () {
		return {
			value : [],
			valueMisc : [],
			valueMenu: [],
			photos: [],
			options: [],
			ck_name: '',
			ck_lname: '',
			ck_email: '',
			ck_phone: '',
			ck_company: '',
			ck_onsitecontact: '',
			ck_additional_info: '',
			ck_customeraccount: '',
			ck_departement: '',
			cardtoken: '',
			totalPrice : 0,
			roomTotalPrice: 0,
			localMiscItems: this.$store.state.operaMiscItems,
			checkboxAgree: false,
			isHidden: true,
			booking_errors: '',
			treatAsEnquiry: false,
			selectedPaymentMethod: 'creditcard',
			maxMenu : window.location.hostname == 'meetings.leonardohotels.co.uk' ? 1 : 7777, // #hack for jurysinns,
			serviceTimeList: [
				{ id : 1, text: "--:--", value: "--:--" }, 
				{ id : 2, text: "00:00", value: "00:00" }, 
				{ id : 3, text: "00:30", value: "00:30" }, 
				{ id : 4, text: "01:00", value: "01:00" }, 
				{ id : 5, text: "01:30", value: "01:30" }, 
				{ id : 6, text: "02:00", value: "02:00" }, 
				{ id : 7, text: "02:30", value: "02:30" }, 
				{ id : 8, text: "03:00", value: "03:00" }, 
				{ id : 9, text: "03:30", value: "03:30" }, 
				{ id : 10, text: "04:00", value: "04:00" }, 
				{ id : 11, text: "04:30", value: "04:30" }, 
				{ id : 12, text: "05:00", value: "05:00" }, 
				{ id : 13, text: "05:30", value: "05:30" }, 
				{ id : 14, text: "06:00", value: "06:00" }, 
				{ id : 15, text: "06:30", value: "06:30" }, 
				{ id : 16, text: "07:00", value: "07:00" }, 
				{ id : 17, text: "07:30", value: "07:30" }, 
				{ id : 18, text: "08:00", value: "08:00" }, 
				{ id : 19, text: "08:30", value: "08:30" }, 
				{ id : 20, text: "09:00", value: "09:00" }, 
				{ id : 21, text: "09:30", value: "09:30" }, 
				{ id : 22, text: "10:00", value: "10:00" }, 
				{ id : 23, text: "10:30", value: "10:30" }, 
				{ id : 24, text: "11:00", value: "11:00" }, 
				{ id : 25, text: "11:30", value: "11:30" }, 
				{ id : 26, text: "12:00", value: "12:00" }, 
				{ id : 27, text: "12:30", value: "12:30" }, 
				{ id : 28, text: "13:00", value: "13:00" }, 
				{ id : 29, text: "13:30", value: "13:30" }, 
				{ id : 30, text: "14:00", value: "14:00" }, 
				{ id : 31, text: "14:30", value: "14:30" }, 
				{ id : 32, text: "15:00", value: "15:00" }, 
				{ id : 33, text: "15:30", value: "15:30" }, 
				{ id : 34, text: "16:00", value: "16:00" }, 
				{ id : 35, text: "16:30", value: "16:30" }, 
				{ id : 36, text: "17:00", value: "17:00" }, 
				{ id : 37, text: "17:30", value: "17:30" }, 
				{ id : 38, text: "18:00", value: "18:00" }, 
				{ id : 39, text: "18:30", value: "18:30" }, 
				{ id : 40, text: "19:00", value: "19:00" }, 
				{ id : 41, text: "19:30", value: "19:30" }, 
				{ id : 42, text: "20:00", value: "20:00" }, 
				{ id : 43, text: "21:00", value: "21:00" }, 
				{ id : 44, text: "20:30", value: "20:30" }, 
				{ id : 45, text: "21:30", value: "21:30" }, 
				{ id : 46, text: "22:00", value: "22:00" }, 
				{ id : 47, text: "22:30", value: "22:30" }, 
				{ id : 48, text: "23:00", value: "23:00" }, 
				{ id : 49, text: "23:30", value: "23:30" },
			]
		}
	},
	components: {
		VuePhoneInput,
		Multiselect,
		MultiDayCheckout,
		PCICaptureToken
	},
    created: function(){
    	this.preFetchInfo();
    	this.venue();
    },
	mounted() {
		document.onreadystatechange = () => { 
			if (document.readyState == "complete") { 
				let footerEl = document.getElementById("footer");
				if(footerEl){
					footerEl.style.display = "block";
				}
			} 
		}
	},
	computed: {
		packageNameString () {
			if(this.checkOutItems[0].package.name){
				const packagenNameMixType = this.checkOutItems[0].package.name;
				let packageName;
				if(typeof packagenNameMixType === "string"){
					packageName = packagenNameMixType
					return packageName
				}
				const packageNameObj = packagenNameMixType
				const lang = this.$store.state.selectedLang;
				
				packageName = packageNameObj[lang] ? packageNameObj[lang] : packageNameObj['en'];
				return packageName
			} else {
				return '';
			}
		}, 
		addOnsTotalPrices () {
			let total = 0;
			let self = this;
			if(this.valueMenu.length == 0 && this.valueMisc.length == 0){
				return total;
			} else {
				this.valueMenu.forEach(element => {
					total += element.price * parseInt(element.amount);
				});

				this.valueMisc.forEach(element => {
					total += element.price * parseInt(element.amount) * self.temp(self.checkOutItems[0].mt_length, element.isHourlyRate);
				});

				return total;
			}
		},
		preFetchInfo(){
			let self = this;
			let localstorage = JSON.parse(localStorage.getItem('operaPayload'));
			let singleDayRoom = [[{"addons":[],"services":[],"currency":"GBP","currencySymbol":"£","delegates":10,"startD":"13-06-2019 09:00","endD":"13-06-2019 11:00","operaStartD":"2019-06-13T09:00:00","operaEndD":"2019-06-13T11:00:00","mt_length":2,"type":"room","room":{"isInstantBookable":1,"code":"SUITE1","id":"148758","name":"Suite 1","layout_name":"Anything goes","layout_code":"_none","opera_layout_code":"","rate_code":"WEB","unit_price":29500,"total_price":29500},"package":{},"total_addons":0,"total_price":29500,"total_services":0}],{"title":"Jurys Inn London Watford","id":92446,"currency":"GBP","hotel_code":"WTI","server":"jurysinn","chain_code":"JI","source_id":"290579674","terms":[],"terms_of_cancellation":"<p>Cancellation Policy – Deposit and Payment</p><br />\n<br />\n<p>Should the Client cancel all or part of this booking the hotel reserves the right to charge the following:</p><br />\n<br />\n<p>Up to 12 weeks prior to the function date       no charge</p><br />\n<br />\n<p>12 weeks to 8 weeks prior to function date    25% of contracted anticipated spend Inc VAT</p><br />\n<br />\n<p>8 weeks to 4 weeks prior to function date       50% of contracted anticipated spend inc. VAT</p><br />\n<br />\n<p>4 weeks to 2 weeks prior to function date       75% of contracted anticipated spend inc. VAT</p><br />\n<br />\n<p>2 weeks to function date                                100% of contracted anticipated spend inc. VAT</p><br />\n<br />\n<p>If accommodation is required, on presentation of the final rooming list, 7 days prior to arrival, all unsold rooms will be released back to the hotel following written confirmation from the client and cancellation charges will apply as above.</p><br />\n<br />\n<p>In the event that a booking, conference and or accommodation, is postponed, the client will be offered three alternative dates within 9 months of the date of postponement.  If the client confirms the booking for a later date the deposits paid will not be lost.  Should the client not be willing to commit to any of the dates offered, deposits paid will be fully forfeited to the hotel. For postponement of the event within 2 weeks prior to function date, the above cancellation charges will apply.          </p><br />\n<br />\n<p>For bookings of 14 rooms or less notice of any cancellations or reduction in the number of rooms received less than 72 hours prior to the arrival date or in the event of a no-show, will result in the client or the guest, as the case may be, being charged the full amount set out in the Meeting Contract. For bookings of 15 rooms or more notice of any cancellations or reduction in the number of rooms received less than 28 days prior to the arrival date or in the event of a no-show, will result in the client or the guest, as the case may be, being charged the full amount set out in the Meeting Contract.</p>","photos":["https://assets-mp.meetingpackage.com/public/styles/horizontal_slider_image/public/venue/Reception_sm.jpg?itok=kcdYOE8R","https://assets-mp.meetingpackage.com/public/styles/horizontal_slider_image/public/venue/Lobby_sm.jpg?itok=fTgx9qeP","https://assets-mp.meetingpackage.com/public/styles/horizontal_slider_image/public/venue/Bar_sm.jpg?itok=FIl-LVw3","https://assets-mp.meetingpackage.com/public/styles/horizontal_slider_image/public/venue/Lobby%203_sm.jpg?itok=9RVf1QK6","https://assets-mp.meetingpackage.com/public/styles/horizontal_slider_image/public/venue/Restaurant_sm.jpg?itok=JSOLZUCl"]}];
			let multiDayRoom = [[{"operaStartD":"2019-06-18T09:00:00","operaEndD":"2019-06-18T15:00:00","startD":"18-06-2019 09:00","endD":"18-06-2019 15:00","endTime":"15:00","mt_length":6,"type":"room","currency":"GBP","currencySymbol":"£","delegates":10,"room":{"isInstantBookable":1,"rate_code":"WEB","code":"SUITE4","name":"Suite 4","layout_code":"_none","layout_name":"Anything goes","id":"148761","price_novat":"","unit_price":29500,"total_price":29500},"package":{},"services":[],"addons":[],"total_services":0,"total_addons":0,"total_price":29500},{"operaStartD":"2019-06-25T09:00:00","operaEndD":"2019-06-25T16:00:00","startD":"25-06-2019 09:00","endD":"25-06-2019 16:00","endTime":"16:00","mt_length":7,"type":"room","currency":"GBP","currencySymbol":"£","delegates":10,"room":{"isInstantBookable":0,"rate_code":"WEB","code":"SUITE5","name":"Suite 5","layout_code":"_none","layout_name":"Anything goes","id":"148762","price_novat":"","unit_price":29500,"total_price":29500},"package":{},"services":[],"addons":[],"total_services":0,"total_addons":0,"total_price":29500}],{"title":"Jurys Inn London Watford","id":92446,"currency":"GBP","hotel_code":"WTI","server":"jurysinn","chain_code":"JI","source_id":"290579674","terms":[],"terms_of_cancellation":"<p>Cancellation Policy – Deposit and Payment</p><br />\n<br />\n<p>Should the Client cancel all or part of this booking the hotel reserves the right to charge the following:</p><br />\n<br />\n<p>Up to 12 weeks prior to the function date       no charge</p><br />\n<br />\n<p>12 weeks to 8 weeks prior to function date    25% of contracted anticipated spend Inc VAT</p><br />\n<br />\n<p>8 weeks to 4 weeks prior to function date       50% of contracted anticipated spend inc. VAT</p><br />\n<br />\n<p>4 weeks to 2 weeks prior to function date       75% of contracted anticipated spend inc. VAT</p><br />\n<br />\n<p>2 weeks to function date                                100% of contracted anticipated spend inc. VAT</p><br />\n<br />\n<p>If accommodation is required, on presentation of the final rooming list, 7 days prior to arrival, all unsold rooms will be released back to the hotel following written confirmation from the client and cancellation charges will apply as above.</p><br />\n<br />\n<p>In the event that a booking, conference and or accommodation, is postponed, the client will be offered three alternative dates within 9 months of the date of postponement.  If the client confirms the booking for a later date the deposits paid will not be lost.  Should the client not be willing to commit to any of the dates offered, deposits paid will be fully forfeited to the hotel. For postponement of the event within 2 weeks prior to function date, the above cancellation charges will apply.          </p><br />\n<br />\n<p>For bookings of 14 rooms or less notice of any cancellations or reduction in the number of rooms received less than 72 hours prior to the arrival date or in the event of a no-show, will result in the client or the guest, as the case may be, being charged the full amount set out in the Meeting Contract. For bookings of 15 rooms or more notice of any cancellations or reduction in the number of rooms received less than 28 days prior to the arrival date or in the event of a no-show, will result in the client or the guest, as the case may be, being charged the full amount set out in the Meeting Contract.</p>","photos":["https://assets-mp.meetingpackage.com/public/styles/horizontal_slider_image/public/venue/Reception_sm.jpg?itok=kcdYOE8R","https://assets-mp.meetingpackage.com/public/styles/horizontal_slider_image/public/venue/Lobby_sm.jpg?itok=fTgx9qeP","https://assets-mp.meetingpackage.com/public/styles/horizontal_slider_image/public/venue/Bar_sm.jpg?itok=FIl-LVw3","https://assets-mp.meetingpackage.com/public/styles/horizontal_slider_image/public/venue/Lobby%203_sm.jpg?itok=9RVf1QK6","https://assets-mp.meetingpackage.com/public/styles/horizontal_slider_image/public/venue/Restaurant_sm.jpg?itok=JSOLZUCl"]}];
			let payload = localstorage;
			let items = payload[0];
			let venue_info = payload[1];
			venue_info.operaServer = venue_info.server;
			venue_info.operaChainCode = venue_info.chain_code;
			venue_info.operaHotelID = venue_info.hotel_code;
			this.photos = venue_info.photos;
			this.$store.commit('setVenueInfo', venue_info);			
            this.$store.commit('setDelegates', items[0].delegates);
            this.$store.commit('setCheckOutItemsOpera', items);
			let d = venue_info;
			d.events = items;
				this.$store.dispatch('createOperaCart', d).then( (d) => {
			}, () => {
				this.showBookingErrors();
			});
            this.$store.dispatch('checkUser').then(() => {
				let userInfo = this.$store.state.userInfo;
				if(userInfo){
					this.ck_name = userInfo.first_name;
					this.ck_lname = userInfo.last_name;
					this.ck_email = userInfo.email;
					this.ck_phone = userInfo.phone;
					this.ck_company = userInfo.company;
				}
				this.$store.commit('setProcessing', 'no');
			});
			
			// If package booking, we don't need to fetch the add ons.
			if(this.$store.state.checkOutItemsOpera[0].type == 'room'){
				this.$store.dispatch('getOperaMenuItems').then((data) => {
					// #loghere
					let operaMenuItemsList = data.body.MeetingFetchMenuItemResponse.MenuItems;
					// Purify list
					let newList = [];
					operaMenuItemsList.forEach(element => {
						let elementPrice = 0;
						if(element.Charges.RevenueTypes.BaseRate.Amount){
							elementPrice = parseFloat(element.Charges.RevenueTypes.BaseRate.Amount);
						} else {
							elementPrice = parseFloat(element.Charges.RevenueTypes.BaseRate[0].Amount);
						}
						elementPrice = elementPrice.toFixed(2);
						let newItem = {
							'id' : element.MenuItemID,
							'name' : element['@attributes'].name1,
							'price' : elementPrice,
							'priceWithCC' : elementPrice + ' ' + this.$store.state.venueInfo.currency,
							'service_time' : '--:--'
						};
						//if(elementPrice > 0){
							newList.push(newItem);
						//}
					});
	
					this.$store.commit('setOperaMenuItems', newList);
					// End Purify list
	
				});
	
				// Get Opera Menus.
				this.$store.dispatch('getOperaMenus').then((data) => {
					// #loghere
					let operaMenusList = data.body.MeetingFetchMenuResponse.Menus;
					
					// Purify list
					let newList = [];
	
					let _operaMenusList = [];
	
					if(operaMenusList.MenuID){ // Only 1 menu
						_operaMenusList.push(operaMenusList);
					} else {
						_operaMenusList = operaMenusList;
					}
	
					_operaMenusList.forEach(element => {
						let price = 0;
						let componentPrice = 0;
						let menuItemsList = [];
						// Package price
						let revenueTypes = element.Charges.RevenueTypes;
						if(revenueTypes){
							if(revenueTypes.BaseRate){
								let elementPrice = 0;
								if(revenueTypes.BaseRate.Amount){
									elementPrice = parseFloat(revenueTypes.BaseRate.Amount);
								} else {
									elementPrice = parseFloat(revenueTypes.BaseRate[0].Amount);
								}
								price += parseFloat(elementPrice);
							} else {
								revenueTypes.forEach(el => {
									let elementPrice = 0;
									if(el.BaseRate.Amount){
										elementPrice = parseFloat(el.BaseRate.Amount);
									} else {
										elementPrice = parseFloat(el.BaseRate[0].Amount);
									}
									price += parseFloat(elementPrice);
								});
							}
						}
	
						menuItemsList.push({
							'id' : element.MenuID,
							'name' : 'Menu',
							'amount' : this.$store.state.delegates,
							'price' : price,
							'priceWithCC' : price + ' ' + this.$store.state.venueInfo.currency,
							'service_time' : '--:--'
						});
	
						// Component price
						let menuItems = element.MenuItems;
						if(menuItems){
							if(menuItems.MenuItemID){ // only 1 menu item.
								if(menuItems.Charges){
									let elementPrice = 0;
									if(menuItems.Charges.RevenueTypes.BaseRate.Amount){
										elementPrice = parseFloat(menuItems.Charges.RevenueTypes.BaseRate.Amount);
									} else {
										elementPrice = parseFloat(menuItems.Charges.RevenueTypes.BaseRate[0].Amount);
									}
									componentPrice += elementPrice;
									menuItemsList.push({
										'id' : menuItems.MenuItemID,
										'name' : menuItems['@attributes'].name1,
										'amount' : this.$store.state.delegates,
										'price' : elementPrice,
										'priceWithCC' : elementPrice + ' ' + this.$store.state.venueInfo.currency,
										'service_time' : '--:--'
									});
								}
							} else {
								menuItems.forEach(el => {
									let elementPrice = 0;
									if(el.Charges){
										if(el.Charges.RevenueTypes.BaseRate.Amount){
											elementPrice = parseFloat(el.Charges.RevenueTypes.BaseRate.Amount);
										} else {
											elementPrice = parseFloat(el.Charges.RevenueTypes.BaseRate[0].Amount);
										}
										componentPrice += elementPrice;
										menuItemsList.push({
											'id' : el.MenuItemID,
											'name' : el['@attributes'].name1,
											'amount' : this.$store.state.delegates,
											'price' : elementPrice,
											'priceWithCC' : elementPrice + ' ' + this.$store.state.venueInfo.currency,
											'service_time' : '--:--'
										});
									}
								});
							}
						}
	
						let finalPrice = (price + componentPrice).toFixed(2);
	
						let newItem = {
							'id' : element.MenuID,
							'name' : element['@attributes'].name,
							'eventType' : element.EventType,
							'amount' : this.$store.state.delegates,
							'price' : finalPrice,
							'priceWithCC' : finalPrice + ' ' + this.$store.state.venueInfo.currency,
							'service_time' : '--:--',
							'menuItems' : menuItemsList
						};
						if(!element['@attributes'].name.toLowerCase().includes('do not')){
							newList.push(newItem);
						}
	
					});
	
					this.$store.commit('setOperaMenus', newList);
				});
				// Get Opera Misc Items.
	
				let format = 'DD-MM-YYYY HH:mm';
				// Start date will be the start date of the first event.
				let _start = moment(items[0].startD, format).format('YYYY-MM-DD');
				// End date will be the end date of the last event plus 1 day.
				let _end = moment(items[items.length - 1 ].endD, format).add(1, 'days').format('YYYY-MM-DD');
				
				let miscPayload = {
					'start_date' : _start,
					'end_date' : _end
				};
				
				this.$store.dispatch('getOperaMiscItems', miscPayload).then((data) => {
					// #loghere
	
					if(data.body){
						let miscItemList = data.body;
						let currency = this.$store.state.venueInfo.currency;
						//  Need to include currency here.
						miscItemList.forEach(item => {
							item.priceWithCC = parseFloat(item.price) == 0 ? 'Free' : parseFloat(item.price).toFixed(2) + ' ' + currency;
							if(item.availability && item.availability[self.convertDate(self.checkOutItems[0].startD)] == 0){
								item.$isDisabled = true;
							} else {
								item.$isDisabled = false;
							}
						});
						this.$store.commit('setOperaMiscItems', miscItemList);
					}
					
				});
			}


			let enquiryBookableRoomCount = 0;
			items.forEach( (event) =>{
				enquiryBookableRoomCount = enquiryBookableRoomCount + parseInt(event.room.isInstantBookable == 1 ? 0: 1);
			});
			if(enquiryBookableRoomCount == items.length){
				this.treatAsEnquiry = true;
			}
		},
		strings(){
            return this.$store.state.strings;
		},
        venue(){
            return  this.$store.state.venueInfo;
        },
		checkOutItems() {
			let items = this.$store.state.checkOutItemsOpera;
			if(items.length == 1){
				if(items[0].type == 'room'){
					this.roomTotalPrice = items[0].room.total_price;
					this.totalPrice = items[0].room.total_price;
				}else{
					this.roomTotalPrice = items[0].package.total_price;
					this.totalPrice = items[0].package.total_price;					
				}
			}
			return items;
		},
		showPaymentMethods(){
			return this.treatAsEnquiry == false && window.location.host != "scandichelsfyr.meetingpackage.com";
		},
		operaMenus() {
			return this.$store.state.operaMenus;
		},
		operaMenuItems() {
			return this.$store.state.operaMenuItems;
		},
		operaMiscItems() {

			return this.$store.state.operaMiscItems;
		},
		userInfo() {
			let userInfo = this.$store.state.userInfo;
			if(userInfo){
				this.ck_name = userInfo.first_name;
				this.ck_lname = userInfo.last_name;
				this.ck_email = userInfo.email;
				this.ck_phone = userInfo.phone;
				this.ck_company = userInfo.company;
			}
        	return this.$store.state.userInfo;
      	},
	},
	watch: {
		addOnsTotalPrices: function(value) {
			let base_total;
			if(this.$store.state.checkOutItemsOpera[0].type == 'room'){
				base_total = this.$store.state.checkOutItemsOpera[0].room.total_price;
			}else{
				base_total = this.$store.state.checkOutItemsOpera[0].package.total_price;
			}
			if(value > 0) {
				value = value * 100;
				this.totalPrice = base_total + value;
			} else {
				this.totalPrice = base_total;
			}
			this.$store.state.checkOutItemsOpera[0].total_price = this.totalPrice;
		}
	},
	methods: {
		convertDate(date){
			return moment(date, 'DD-MM-YYYY HH:mm').format('YYYY-MM-DD');
		},
		isServiceTimeBetween(serviceTime){
			if(this.checkOutItems.length > 0){
				let format = 'DD-MM-YYYY HH:mm';
				let date = moment(this.checkOutItems[0].startD, format).format('DD-MM-YYYY');
				let beforeTime = moment(this.checkOutItems[0].startD, format);
				let afterTime = moment(this.checkOutItems[0].endD, format);
				let time = moment(date + ' ' + serviceTime, format);
				if (time.isBetween(beforeTime, afterTime) || time.isSame(beforeTime) || time.isSame(afterTime)) {
					return true;
				} else {
					return false;
				}
			}
		},
		temp(meeting_length, isHourlyRate){
			if(isHourlyRate){
				return parseInt(meeting_length);
			} else {
				return 1;
			}
		},
		isUrl(url){
			return hf.isValidURL(url);
		},
		toggleDetails(){
            this.isHidden = !this.isHidden
		},
		cardTokenCaptured(token){
			this.cardtoken = token;
			this.createOperaBooking();			
		},
		cardTokenFailure(token){
			this.showBookingErrors(this.$store.state.strings.invalidCard);
		},

		showBookingErrors (customText) {
            this.$modal.show({
                template: `
                <div>
                		<div class="v--modal-top-right"></div>
                				<div class="v--modal-box v--modal vue-dialog">
                				<div class="dialog-content">
                					<div class="dialog-c-title">{{title}}
                					     <div class="top-right" slot="top-right">
												<button @click="$emit('close')">X</button>
										</div>
                					</div>
                					<div class="dialog-c-text">
                					<div slot="text" v-html=text>{{text}}</div>
									</div>
									<div style="margin-top:25px;">
										<button style="cursor:pointer;float:right" @click="$emit('close')">Close</button>
									</div>	
								</div>
                		</div>
                		</div>
  `,
                props: ['text', 'title']
            }, {

                text: customText ? customText: this.$store.state.strings.experiencingTechnicalProblems,
                title: this.$store.state.strings.errorHappened

            }, {
                height: 'auto'
            }, {
                'before-close': (event) => { 
					window.location.reload();
				}
            });
		},
		showTermsModal () {
            this.$modal.show({
                template: `
                <div>
                		<div class="v--modal-top-right"></div>
                				<div class="v--modal-box v--modal vue-dialog">
                				<div class="dialog-content">
                					<div class="dialog-c-title">{{title}}
                					     <div class="top-right" slot="top-right">
												<button @click="$emit('close')">X</button>
										</div>
                					</div>
                					<div class="dialog-c-text">
                					<div slot="text" v-html=text>{{text}}</div>
									</div>
									<div style="margin-top:25px;">
										<button style="cursor:pointer;float:right" @click="$emit('close')">Close</button>
									</div>	
								</div>
                		</div>
                		</div>
  `,
                props: ['text', 'title']
            }, {

                text: this.$store.state.venueInfo.terms,
                title: this.$store.state.strings.termsNConditions

            }, {
                height: 'auto'
            }, {
                'before-close': (event) => {}
            });
        },
		getCancellationTermTranslation(string) {
			try {
				const lang = this.$store.state.selectedLang
				const returnString = JSON.parse(string)[lang] ? JSON.parse(string)[lang] : JSON.parse(string).en
				return returnString
			} catch {
				return string
			}
		},
        show () {
            this.$modal.show({
                template: `
                <div>
                		<div class="v--modal-top-right"></div>
                				<div class="v--modal-box v--modal vue-dialog">
                				<div class="dialog-content">
                					<div class="dialog-c-title">{{title}}
                					     <div class="top-right" slot="top-right">
												<button @click="$emit('close')">X</button>
										</div>
                					</div>
                					<div class="dialog-c-text">
                					<div slot="text" v-html="text"></div>
                					</div>
                				</div>
                		</div>
                		</div>
  `,
                props: ['text', 'title']
            }, {

                text: this.getCancellationTermTranslation(!this.treatAsEnquiry ? this.$store.state.venueInfo.terms_of_cancellation : this.$store.state.venueInfo.inquiry_venue_terms_cancellation !== '' ? this.$store.state.venueInfo.inquiry_venue_terms_cancellation : this.$store.state.venueInfo.terms_of_cancellation),
                title: this.$store.state.strings.cancelationPolicy,
            }, {
                height: 'auto'
            }, {
                'before-close': (event) => { console.log('this will be called before the modal closes'); }
            });
        },
        hide () {
            this.$modal.hide('dialog');
        },
		changeTotal(event) {
			let inputChangeID = event.target.attributes['data-id'].value;
		
			this.operaMiscItems.forEach(el => {
				if( parseInt(el.id) == parseInt(inputChangeID) ){
					el.amount = parseInt(event.target.value);
				}
			});
			
			this.$store.commit('setOperaMiscItems', this.operaMiscItems);

			this.valueMisc.forEach( (element, index) => {
				if( parseInt(element.id) == parseInt(inputChangeID) ){
					element.amount = parseInt(event.target.value);
					Vue.set(this.valueMisc, index, element);
				}
			});
		},
		changeMenuTotal(event){
			let inputChangeID = event.target.attributes['data-id'].value;

			this.operaMenus.forEach(el => {
				if( parseInt(el.id) == parseInt(inputChangeID) ){
					el.amount = parseInt(event.target.value) * 100;
				}
			});

			this.$store.commit('setOperaMenus', this.operaMenus);
		
			this.valueMenu.forEach( (element,index) => {
				if( parseInt(element.id) == parseInt(inputChangeID) ){
					element.amount = parseInt(event.target.value);
					Vue.set(this.valueMenu, index, element);
				}
			});
		},
		changeMiscServiceTime(event){
			let inputChangeID = event.target.attributes['data-id'].value;
		
			this.operaMiscItems.forEach(el => {
				if( parseInt(el.id) == parseInt(inputChangeID) ){
					el.service_time = event.target.value;
				}
			});

			this.$store.commit('setOperaMiscItems', this.operaMiscItems);

			this.valueMisc.forEach( (element, index) => {
				if( parseInt(element.id) == parseInt(inputChangeID) ){
					element.service_time = event.target.value;
					Vue.set(this.valueMisc, index, element);
				}
			});

		},
		changeMenuServiceTime(event){
			let inputChangeID = event.target.attributes['data-id'].value;
			this.operaMenus.forEach(el => {
				if( parseInt(el.id) == parseInt(inputChangeID) ){
					el.service_time = event.target.value;
				}
			});

			this.$store.commit('setOperaMenus', this.operaMenus);

			this.valueMenu.forEach( (element, index) => {
				if( parseInt(element.id) == parseInt(inputChangeID) ){
					element.service_time = event.target.value;
					Vue.set(this.valueMenu, index, element);
				}
			});
		},
		submitForm() {
			this.$validator.validateAll().then((result) => {
				if(result == false){
					let fieldName = this.$validator.errors.items[0].field;
					if(this.$refs[fieldName]){
						this.$refs[fieldName].focus();
					}
				}else{
					if(this.selectedPaymentMethod == "creditcard" && !this.treatAsEnquiry && this.showPaymentMethods){
						this.$emit('reloadIframe', '');
					}else{
						this.createOperaBooking();
					}
				}
			});
		},
		createOperaBooking() {
			let startD = this.$store.state.datetime;
			let operaStartD = moment(startD, 'DD-MM-YYYY HH:mm');
			operaStartD = operaStartD.format('YYYY-MM-DDTHH:mm:ss');
			let endD = moment(startD, 'DD-MM-YYYY HH:mm');
			let mt_length = '';
			let currentTab = this.$store.state.currentTab;
			let baseUrl = this.$store.state.baseUrl;

			if(this.$store.state.meeting_length == 'overnight'){
			mt_length = 24;
			} else if(this.$store.state.meeting_length == 'twodays'){
			mt_length = 36;
			} else {
			mt_length = parseInt(this.$store.state.meeting_length);
			}

			endD = endD.add(mt_length, 'hours');
			let operaEndD = endD;
			endD = endD.format('DD-MM-YYYY HH:mm');
			operaEndD = operaEndD.format('YYYY-MM-DDTHH:mm:ss');
			this.$store.commit('setProcessing', 'yes');
			let lang = this.$store.state.selectedLang;
			if(lang == 'en'){
			lang = '';
			} else {
			lang = '/' + lang;
			}
			
			let ajaxUrl = '';
			
			ajaxUrl = baseUrl + '/apiv2/opera/create-booking';
			let sentData = {};
			//general info
			// Check if there is discount code in use
			sentData.discount_code = this.$cookie.get('discount_code');
			sentData.hotel_code = this.$store.state.venueInfo.hotel_code;
			sentData.block_name = this.$store.state.venueInfo.block_name;
			sentData.server = this.$store.state.venueInfo.server;
			sentData.type = this.$store.state.checkOutItemsOpera[0].type;
			sentData.currency = this.$store.state.venueInfo.currency;
			sentData.notes = this.ck_additional_info;
			sentData.source_id = this.$store.state.venueInfo.source_id;
			sentData.chain_code = this.$store.state.venueInfo.chain_code;
			sentData.card_token = this.cardtoken;
			sentData.venue_id = this.$store.state.venueInfo.id;
			//userinfo
			sentData.firstName = this.ck_name;
			sentData.lastName = this.ck_lname;
			sentData.phone = this.ck_phone;
			sentData.email = this.ck_email;
			sentData.phone_country = this.$store.state.countryPhoneCode;
			sentData.company = this.ck_company;
			sentData.customer_account = this.ck_customeraccount;
			sentData.departement = this.ck_departement;
			sentData.onSiteContact = this.ck_onsitecontact ? this.ck_onsitecontact : this.ck_name + ' ' + this.ck_lname;
			sentData.paymentMethod = this.showPaymentMethods ? this.selectedPaymentMethod: "none";
			sentData.block_name = 'CONFIRMED - '  + sentData.company;
			sentData.cart_id = this.$store.state.cartId;
			//order info
			sentData.events = this.$store.state.checkOutItemsOpera;
			let miscItems = this.valueMisc;
			let menus = this.valueMenu;	
			sentData.totalPrice = parseFloat(this.checkOutItems.reduce((sum, value) => { return sum + parseInt(value.total_price); }, 0));
			sentData.events = sentData.events.map(function(event) {
				let ev = {};
				ev.start = event.operaStartD;
				ev.end = event.operaEndD;
				ev.layout_code = event.room.layout_code;
				if(event.type == 'room'){
					ev.price = event.room.total_price;
					ev.price_total = event.room.total_price;
				}else{
					ev.price = event.package.unit_price;
					ev.price_total = event.package.total_price;
				}
				ev.final_price = ev.price_total;
				ev.room = event.room.id;
				ev.room_code = event.room.code;
				ev.room_rate_code = event.room.rate_code;
				ev.isInstantBookable = event.room.isInstantBookable;
				ev.package_id = event.package.id;
				ev.delegates = event.delegates;
				ev.package_name =  event.package.name;
				ev.package_rate_code =  event.package.rate_code;
				ev.package_min = event.package.package_min;
				if(sentData.events.length > 1){
					ev.miscItems = event.addons;
					ev.menus = event.services;	
				}else{
					ev.miscItems = miscItems;
					ev.menus = menus;	
				}
				ev.opera_setup_style = event.room.opera_layout_code;	
				return ev;
			});
				this.$cookie.set('isEnquiryBooking', this.treatAsEnquiry, { expires: '10m' });
				Vue.http.post(ajaxUrl, sentData).then(response => {
					// #loghere
					let data = response.body;
					let url = '';

					if(data.status == 'payment_error'){
						url = baseUrl + lang + '/payment/failure';
						window.location.href = url;	
						return;
					}

					if(!data.order_id){
						this.showBookingErrors();
						this.$store.commit('setProcessing', 'no');
						return;
					}					
					if(this.$store.state.userInfo == false){
						url = baseUrl + lang + '/thank-you-anon';
					} else {
						url = baseUrl + lang + '/checkout/' + data.order_id;
					}
					localStorage.removeItem('operaPayload');
					window.location.href = url;	
					}, response => {
						this.showBookingErrors();
						this.$store.commit('setProcessing', 'no');
				});
				return;			
		}
	}
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
	.paymentTypeInputWrapper label {
		display: inline
	}
	.checkBoxAgree label {
		display: inline-block
	}
	.info-label {
		float: left;
		width: 50%;
	}

	.info {
		float: left;
		width: 50%;
		text-align: right;
	}

	.full-info-item {
		margin-bottom: 20px;
		padding-bottom: 10px;
	}

	.checkout-title {
		border-bottom: 1px solid black;
		margin-bottom: 20px;
	}

	img {
		width: 100%;
		height: 300px;
	}

	.room-pic, .checkout-room-title {
		padding-bottom: 10px;
		/*border-bottom: 1px solid #ccc;*/
		margin-bottom: 10px;
	}

	.totalPrice {
		border-top: 1px solid #ccc;
		padding-top: 20px;
	}

	.addonTotal {
		border-top: 1px solid #ccc;
		padding-top: 15px;
	}

	.form__note {
		top: 22px;
	}

	.form__label {
		font-size: 16px;
	}

	.form__textarea {
		height: 150px;
		font-size: 14px;
	}

	form {
		margin-bottom: 50px;
	}

	.multiselect {
		margin-bottom: 20px;
	}

	.multiselect__tag {
		background: #0055a9
	}

	.multiselect__tag-icon:after {
		color: white;
	}

	.addons h3{
        font-size: 18px;
        margin-top:18px;
    }
	.checkBoxAgree {
		margin-top: -5px !important;
		margin-bottom: 20px !important;
	}

	.v--modal-block-scroll {
		overflow: hidden;
		width: 100vw;
	}
	.v--modal-overlay {
		position: fixed;
		box-sizing: border-box;
		left: 0;
		top: 0;
		width: 100%;
		height: 100vh;
		background: rgba(0, 0, 0, 0.2);
		z-index: 999;
		opacity: 1;
	}
	.v--modal-overlay.scrollable {
		height: 100%;
		min-height: 100vh;
		overflow-y: auto;
		-webkit-overflow-scrolling: touch;
	}
	.v--modal-overlay .v--modal-background-click {
		min-height: 100%;
		width: 100%;
		padding-bottom: 10px;
	}
	.v--modal-overlay .v--modal-box {
		position: relative;
		overflow: hidden;
		box-sizing: border-box;
	}
	.v--modal-overlay.scrollable .v--modal-box {
		margin-bottom: 2px;
		/* transition: top 0.2s ease; */
	}
	.v--modal {
		background-color: white;
		text-align: left;
		border-radius: 3px;
		box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);
		padding: 0;
	}
	.v--modal.v--modal-fullscreen {
		width: 100vw;
		height: 100vh;
		margin: 0;
		left: 0;
		top: 0;
	}
	.v--modal-top-right {
		display: block;
		position: absolute;
		right: 0;
		top: 0;
	}
	.overlay-fade-enter-active,
	.overlay-fade-leave-active {
		transition: all 0.2s;
	}
	.overlay-fade-enter,
	.overlay-fade-leave-active {
		opacity: 0;
	}
	.nice-modal-fade-enter-active,
	.nice-modal-fade-leave-active {
		transition: all 0.4s;
	}
	.nice-modal-fade-enter,
	.nice-modal-fade-leave-active {
		opacity: 0;
		transform: translateY(-20px);
	}

	.vue-modal-resizer {
		display: block;
		overflow: hidden;
		position: absolute;
		width: 12px;
		height: 12px;
		right: 0;
		bottom: 0;
		z-index: 9999999;
		background: transparent;
		cursor: se-resize;
	}
	.vue-modal-resizer::after {
		display: block;
		position: absolute;
		content: '';
		background: transparent;
		left: 0;
		top: 0;
		width: 0;
		height: 0;
		border-bottom: 10px solid #ddd;
		border-left: 10px solid transparent;
	}
	.vue-modal-resizer.clicked::after {
		border-bottom: 10px solid #369be9;
	}

	.vue-dialog div {
		box-sizing: border-box;
	}
	.vue-dialog .dialog-flex {
		width: 100%;
		height: 100%;
	}
	.vue-dialog .dialog-content {
		flex: 1 0 auto;
		width: 100%;
		padding: 15px;
		font-size: 14px;
	}
	.vue-dialog .dialog-c-title {
		font-weight: 600;
		padding-bottom: 15px;
	}
	.vue-dialog .dialog-c-text {
	}
	.vue-dialog .vue-dialog-buttons {
		display: flex;
		flex: 0 1 auto;
		width: 100%;
		border-top: 1px solid #eee;
	}
	.vue-dialog .vue-dialog-buttons-none {
		width: 100%;
		padding-bottom: 15px;
	}
	.vue-dialog-button {
		font-size: 12px !important;
		background: transparent;
		padding: 0;
		margin: 0;
		border: 0;
		cursor: pointer;
		box-sizing: border-box;
		line-height: 40px;
		height: 40px;
		color: inherit;
		font: inherit;
		outline: none;
	}
	.vue-dialog-button:hover {
		background: rgba(0, 0, 0, 0.01);
	}
	.vue-dialog-button:active {
		background: rgba(0, 0, 0, 0.025);
	}
	.vue-dialog-button:not(:first-of-type) {
		border-left: 1px solid #eee;
	}
	.accordion-toggle{
		border-bottom: 1px solid rgba(0,0,0,.125);
		border-radius: .25rem;
		cursor:pointer;
		margin-bottom: 20px;
	}
	.accordion-block .btn-info{
		background: rgb(0, 85, 169);
	}
	.accordion-plus, .accordion-minus{
		font-weight: 400;
		float: right;
		font-size: 25px;
		line-height: 20px;
	}
	.accordion-plus{
	   	margin-left: 10px;
	}
	.accordion-minus{
	   	margin-left: 16px;
	}

	:not(.collapsed) > .accordion-plus{
		display: none;
	}
	.collapsed > .accordion-plus{
		display: block;
	}

	.collapsed > .accordion-minus{
		display: none;
	}
	:not(.collapsed) > .accordion-minus{
		display: block;
	}
	.multiday-summary{
		padding:0px;
	}
	.venue-details-item .card{
		border:none!important;
	}
	.venue-details-item .card-body{
		padding-top: 0px;
		padding-bottom: 5px;
		padding-right: 15px;
		padding-left: 15px;
	}
	.accordation-price{
		float: right;
	}
	.hide{
		display:none;
	}
	.product-info{
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;		
	}
	@media screen and (max-width: 992px) {
		.venue-summary {
			display:none;
		}
	}
	@media screen and (max-width: 1200px) {
		.container{
			padding: 30px;
		}
	}
</style>
<style>
	.amountInput {
		width: 20% !important;
	}
	.serviceTimeInput {
		width: 25% !important;
	}

	.tableCellClass{
		vertical-align: middle !important;
	}
	.vue-dialog-button{
		text-transform: capitalize!important;
		font-size: 16px!important;
		text-align: center!important;
		display: inline-block!important;
		padding: .75em 1em!important;
		text-decoration: none!important;
		border-radius: 0px!important;
		transition: all .35s cubic-bezier(.2,.7,.3,1)!important;
	}
	.cancelationPolicyLink{
		cursor:pointer;
		text-transform: lowercase;
	}
	.cancelationPolicyLink:hover{
		text-decoration: underline;
	}
	.dialog-c-title{
		font-weight: 600;
		font-size: 18px;
		margin-bottom: 15px;
		padding-bottom: 5px!important;
		border-bottom: 1px solid;
	}
	.top-right{
		position: absolute;
		right: 5px;
		top: 5px;
		background: none;
	}
	.top-right button{
		background: none!important;
		color: black!important;
		border: none!important;
		cursor:pointer;
		outline:none!important;
	}
	.dialog-c-text{
		overflow-y: scroll;
		max-height: 350px;		
	}
	.top-right button:focus {outline:none!important;}
	.paymentType{
		margin-top:50px;
	}
	.selectPaymentType, .accountcredits{
		margin-left:15px;
	}
	.accountcredits{
		margin-top:10px;
		margin-bottom:80px;
	}
	.account-credits-label-info{
		padding-top:5px;
		font-style:italic;
		font-size:12px;
		font-weight:400;
	}
</style>

